import assetPath from '/app/xinglets/network/entry-logged-out/src/components/get-discovered/assets/discovered-background-wide.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')